import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingFallback from "@/components/ui/LoadingFallback";

const LoginPage = () => {
  const { login, isLoading, isAuthenticated, token } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const from =
    (location.state as { returnTo?: string } | undefined)?.returnTo || "/";

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(from, { replace: true });
      return;
    }
    const initiateLogin = async () => {
      // If there's no auth code and we're not loading, start login
      if (
        !isLoading &&
        !isAuthenticated &&
        !location.search.includes("code=")
      ) {
        await login();
      }
    };

    initiateLogin();
  }, [isLoading, isAuthenticated, from, location.search, login, navigate]);

  return <LoadingFallback />;
};

export default LoginPage;
